import { render, staticRenderFns } from "./ListGiveaways.vue?vue&type=template&id=4c67525e&scoped=true"
import script from "./ListGiveaways.vue?vue&type=script&lang=js"
export * from "./ListGiveaways.vue?vue&type=script&lang=js"
import style0 from "./ListGiveaways.vue?vue&type=style&index=0&id=4c67525e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67525e",
  null
  
)

export default component.exports